module.exports = __webpack_public_path__ + "static/media/PasswordReset.ef82eb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/PasswordReset.png
// module id = 238
// module chunks = 0